import MeetingSummaryUnEditable from './MeetingSummaryUnEditable';

export default MeetingSummaryUnEditable;
